import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import reducer from './contat-us';
import * as home from './home';
import * as about from './about';
import * as news from './news';
import * as services from './services';
import * as contacts from './contacts';
import * as general from './general';
import * as serviceDetail from './service-detail';
import * as newsDetail from './news-detail';
import * as interviews from './interviews';

export default combineReducers({
  routing,
  form,
  [home.REDUCER_NAME]: home.reducer,
  [about.REDUCER_NAME]: about.reducer,
  [news.REDUCER_NAME]: news.reducer,
  [services.REDUCER_NAME]: services.reducer,
  [contacts.REDUCER_NAME]: contacts.reducer,
  [general.REDUCER_NAME]: general.reducer,
  [serviceDetail.REDUCER_NAME]: serviceDetail.reducer,
  [newsDetail.REDUCER_NAME]: newsDetail.reducer,
  [interviews.REDUCER_NAME]: interviews.reducer,
  contactsUs: reducer
});



// WEBPACK FOOTER //
// ./src/redux/modules/reducer.js